import Vue from 'vue'
import Router from 'vue-router'


const shareindex = resolve => require(['@/page/inputphone'], resolve);
const Index = resolve => require(['@/components/home'], resolve);
const inputAddress = resolve => require(['@/components/inputAddress'], resolve);
const Rule = resolve => require(['@/components/activeRule'], resolve);
const prizeList = resolve => require(['@/components/prizeList'], resolve);

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/miguplay/html/getNewUser12/',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/prize',
      name: 'prizeList',
      component: prizeList
    },
    {
      path: '/address/:id/:addtype/:addrEndTime?',//奖品记录id值/用户地址填写状态（1未填写 2已填写可修改 3仅查看） 
      name: 'inputAddress',
      component: inputAddress
    },
    {
      path: '/shareindex',
      name: 'shareindex',
      component: shareindex,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/rule',
      name: 'rule',
      component: Rule,
      meta: {
        keepAlive: false
      }
    },
    
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.name === 'home') {
      // setTimeout(() => {
      //   if (savedPosition) {
      //     console.log('xy', savedPosition.x, savedPosition.y)
      //     window.scrollTo(savedPosition.x, savedPosition.y)
      //   }
      // }, 500)
      // return {savedPosition}
    }
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js